

















import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'

const BORDERRADIUS = [
  'rounded-none',
  'rounded-sm',
  'rounded',
  'rounded-md',
  'rounded-lg',
  'rounded-xl',
  'rounded-2xl',
  'rounded-3xl',
  'rounded-full',
]
const ELEVATION = [
  'shadow-none',
  'shadow-sm',
  'shadow',
  'shadow-md',
  'shadow-lg',
  'shadow-xl',
  'shadow-2xl',
]

/**
 * 카드 컴포넌트 입니다.
 */
@Component
export default class HdsCard extends Vue {
  name: string = 'HdsCard'

  /**
   * 너비를 지정합니다.
   */
  @Prop({
    type: String,
  })
  width?: string

  /**
   * 높이를 지정합니다.
   */
  @Prop({
    type: String,
  })
  height?: string

  /**
   * 테두리 스타일을 선택합니다.
   */
  @Prop({
    type: String,
    default: 'none',
  })
  borderStyle!: string

  /**
   * 테두리 색을 지정합니다.
   */
  @Prop({
    type: String,
  })
  borderColor?: string

  /**
   * 테두리 굵기를 선택합니다.
   */
  @Prop({
    type: String,
    default: 'thin',
    validator: function (value) {
      return ['thin', 'medium', 'thick'].indexOf(value) !== -1
    },
  })
  borderWidth!: string

  /**
   * Border Radius 값입니다. 0~8
   */
  @Prop({
    type: Number,
    default: 2,
  })
  borderRadius!: number

  /**
   * Elevation 값입니다. (box-shadow) 0~6
   */
  @Prop({
    type: Number,
    default: 4,
  })
  elevation!: number

  /**
   * 텍스트 정렬을 선택합니다.
   */
  @Prop({
    type: String,
    default: 'left',
  })
  textAlign!: string

  /**
   * 카드 배경 색상을 지정합니다.
   */
  @Prop({
    type: String,
  })
  backgroundColor?: string

  get titleClasses() {
    return {
      'hds-title': true,
    }
  }

  get subtitleClasses() {
    return {
      'hds-subtitle': true,
    }
  }

  get contentClasses() {
    return {
      'hds-content': true,
    }
  }

  get actionsClasses() {
    return {
      'hds-actions': true,
    }
  }

  get cardClasses() {
    return {
      'hds-card': true,
      'hds-card--thin': this.borderWidth === 'thin',
      'hds-card--medium': this.borderWidth === 'medium',
      'hds-card--thick': this.borderWidth === 'thick',
      [`hds-card--border-${this.borderStyle}`]: true,
      [`hds-card--text-${this.textAlign}`]: true,
      [BORDERRADIUS[this.borderRadius]]: true,
      [ELEVATION[this.elevation]]: true,
    }
  }

  get cardStyles() {
    return {
      width: this.width,
      height: this.height,
      backgroundColor: this.backgroundColor,
      borderColor: this.borderColor,
    }
  }
}
